import { cloneDeep } from 'lodash-es';
import i18n from '@/plugins/i18n';
export abstract class AbstractModel {
    /*public t = i18n.global.t;
    public locale = i18n.global.locale;*/

    //public to solve issue with template errors in phpstorm
    public _fieldCache = markRaw<Record<string, Record<string | number, string | boolean>>>({});

    /**
     * public to avoid issue with TS errors in templates
     */
    public get locale() {
        return i18n.global.locale.value;
    }

    /**
     * public to avoid issue with TS errors in templates
     */
    public get t() {
        return i18n.global.t;
    }

    public _lazyLoad(key: string, subKey: string | number | boolean | null, compute: () => string | boolean): any {
        key = key + this.locale;

        this._fieldCache[key] ??= {};

        const safeSubKey = String(subKey);

        if (safeSubKey in this._fieldCache[key]) {
            return this._fieldCache[key][safeSubKey];
        }

        return (this._fieldCache[key][safeSubKey] = compute());
    }

    public clone<T extends this>(): T {
        return cloneDeep(this) as T;
    }

    public logUnwrappedValues() {
        const result: Record<string, any> = {};

        for (const key of Object.keys(this)) {
            const val = (this as Record<string, any>)[key];
            result[key] = isRef(val) ? val.value : val;
        }

        console.log(result);
    }
}
